import styled from "styled-components";
import Skill from "./Skill";
import { skills } from "../data";

const Skills = () => {
	return (
		<Container>
			<h1>Skills</h1>
			<Grid>
				{skills.map((skill, idx) => (
					<Skill key={idx} name={skill.name} deg={skill.deg} />
				))}
			</Grid>
		</Container>
	);
};

export default Skills;

const Container = styled.div`
	padding-bottom: 3rem;
	h1 {
		font-size: 4.5rem;
		margin-bottom: 6rem;
		text-align: center;
		@media screen and (max-width: 500px) {
			font-size: 3.5rem;
			margin-bottom: 2rem;
		}
	}
`;
const Grid = styled.div`
	display: grid;
	justify-content: center;
	grid-template-columns: repeat(2, auto);
	grid-column-gap: 5rem;
	grid-row-gap: 2rem;
	@media screen and (max-width: 1110px) {
		grid-template-columns: auto;
	}
`;
